import React from "react";
import * as Output from "../Text";
import { Wizard } from "@vwfs-bronson/bronson-react";
import Route from "../common/Navigation";
import { isHeycarDealer } from "../common/JourneyType";
import { Brand } from "@busdk/storefront-service/dist/models/enums";

function NavigationRoute(props) {
  const { history, location, originSystem } = props;
  const brand = process.env.REACT_APP_BRAND;

  const getLinks = () => {
    return [
      {
        path: [Route.FullApplicationForm, Route.Summary],
        label: Output.resolve("pages.heyCar.stepper.form"),
      },
      {
        path: [
          Route.BoniRefused,
          Route.BoniSuccessDealer,
          Route.BoniSuccessUCC,
        ],
        label: Output.resolve("pages.heyCar.stepper.creditCheck"),
      },
      {
        path: [Route.DocumentUpload, Route.DocumentUploadSuccess],
        label: Output.resolve("pages.heyCar.stepper.documents"),
      },
      {
        path: [
          Route.Esign,
          Route.EsignApproved,
          Route.EsignRefused,
          Route.EsignSuccess,
          Route.EsignFailed,
        ],
        label: Output.resolve("pages.heyCar.stepper.signature"),
      },
    ];
  };
  const links = getLinks().splice(
    0,
    isHeycarDealer(originSystem) ? 2 : 4
  );
  const currentIndex = Math.max(
    0,
    links.findIndex((link) =>
      Array.isArray(link.path)
        ? link.path.some((v) => location.pathname.endsWith(v))
        : location.pathname.endsWith(link.path)
    )
  );

  return (
    <Wizard
      collapsedText={"Navigation"}
      collapsedCounter={`${currentIndex + 1}/${links.length}`}
      className={`u-mb-large${brand === Brand.VWFS ? " u-mt" : ""}`}
    >
      {links.map((link, index) => (
        <Wizard.Item
          key={index}
          done={index < currentIndex}
          active={index === currentIndex}
          onClick={() => {
            if (link.enabled) {
              history.push(link.target);
            }
          }}
        >
          {link.label}
        </Wizard.Item>
      ))}
    </Wizard>
  );
}

NavigationRoute.propsTypes = {};

export { NavigationRoute };
